import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './UserSidebar.css';

const UserSidebar = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const [openMenus, setOpenMenus] = useState({});

    // Define menu structure
    const menuItems = [
        {
            path: '/dashboard',
            name: t('home', 'Home'),
            icon: 'bi-house-door'
        },
        {
            path: '/markets',
            name: t('market', 'Market'),
            icon: 'bi-graph-up'
        },
        {
            path: '/holdings',
            name: t('holdings', 'Holdings'),
            icon: 'bi-pie-chart'
        },
        {
            id: 'assets',
            name: t('my_assets', 'My Assets'),
            icon: 'bi-wallet2',
            children: [
                { path: '/deposit', name: t('deposit', 'Deposit') },
                { path: '/withdraw', name: t('withdraw', 'Withdraw') },
                { path: '/wallet', name: t('vault', 'Vault') },
                { path: '/financial-details', name: t('history', 'History') }
            ]
        },
        {
            id: 'payment',
            name: t('payment_methods', 'Payment Methods'),
            icon: 'bi-credit-card',
            children: [
                { path: '/my-bank-card', name: t('menu_bank_cards', 'Bank Cards') },
                { path: '/my-crypto-wallet', name: t('menu_crypto_wallets', 'Crypto Wallets') }
            ]
        },
        {
            path: '/profile',
            name: t('my_account', 'My Account'),
            icon: 'bi-person'
        }
    ];

    // Effect to keep submenus open if a child route is active
    useEffect(() => {
        const newOpenMenus = { ...openMenus };
        let changed = false;

        menuItems.forEach(item => {
            if (item.children) {
                const hasActiveChild = item.children.some(child => location.pathname === child.path);
                if (hasActiveChild && !newOpenMenus[item.id]) {
                    newOpenMenus[item.id] = true;
                    changed = true;
                }
            }
        });

        if (changed) {
            setOpenMenus(newOpenMenus);
        }
    }, [location.pathname]);

    const toggleMenu = (id) => {
        setOpenMenus(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const handleLinkClick = () => {
        if (onClose) onClose();
    };

    return (
        <>
            <div className={`user-sidebar-overlay ${isOpen ? 'show' : ''}`} onClick={onClose} />
            <div className={`user-sidebar-container ${isOpen ? 'open' : ''}`}>
                <div className="user-sidebar-header">
                    <div className="d-flex align-items-center">
                        <img src="/assets/images/logo.png" alt="Logo" style={{ width: '32px', height: '32px', marginRight: '10px' }} />
                        <span className="user-sidebar-title">{t('menu_menu', 'Menu')}</span>
                    </div>
                    <button className="btn btn-link text-white p-0" onClick={onClose}>
                        <i className="bi bi-x-lg fs-5"></i>
                    </button>
                </div>

                <div className="user-sidebar-nav">
                    {menuItems.map((item) => (
                        <div key={item.id || item.path} className="nav-item-wrapper">
                            {item.children ? (
                                <>
                                    <div
                                        className={`sidebar-link ${item.children.some(c => location.pathname === c.path) ? 'parent-active' : ''}`}
                                        onClick={() => toggleMenu(item.id)}
                                    >
                                        <i className={`bi ${item.icon}`}></i>
                                        <span className="menu-text">{item.name}</span>
                                        <i className={`bi bi-chevron-down arrow-icon ${openMenus[item.id] ? 'open' : ''}`}></i>
                                    </div>

                                    <div
                                        className="submenu-container"
                                        style={{ maxHeight: openMenus[item.id] ? '500px' : '0' }}
                                    >
                                        {item.children.map(child => (
                                            <NavLink
                                                key={child.path}
                                                to={child.path}
                                                className={({ isActive }) => `submenu-link ${isActive ? 'active' : ''}`}
                                                onClick={handleLinkClick}
                                            >
                                                <i className="bi bi-dot"></i>
                                                <span>{child.name}</span>
                                            </NavLink>
                                        ))}
                                    </div>
                                </>
                            ) : (
                                <NavLink
                                    to={item.path}
                                    className={({ isActive }) => `sidebar-link ${isActive ? 'active-root' : ''}`}
                                    onClick={handleLinkClick}
                                >
                                    <i className={`bi ${item.icon}`}></i>
                                    <span className="menu-text">{item.name}</span>
                                </NavLink>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default UserSidebar;
